import { createSelector } from 'reselect';
import { getStream } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { ModuleType } from '../../types/modules';
import {
  ProfileSkin,
  premiumSkins,
  officialSkin,
  customSkin,
  ProfileSkinsSlice,
  profileSkinsStreamId,
} from '../../types/profileSkins';
import { getModuleDataByModuleType } from './modules';

const getState = (state): ProfileSkinsSlice => state.profileSkins;

export const getActiveSkin = createSelector([getState], state => {
  return state.activeSkin;
});

export const getCustomSkin = createSelector([getState], state => {
  return state.customSkin || customSkin;
});

export const isSkinSelectorShown = state => getState(state).skinSelectorShown;

export const isSkinSaving = state => getState(state).isSkinSaving;

export const getProfileSkin = (
  state,
  isPapiFlagEnabled: boolean
): ProfileSkin | undefined => {
  // active skin comes first when the selector is open
  const activeSkin = getActiveSkin(state);
  if (activeSkin && isSkinSelectorShown(state)) {
    return activeSkin;
  }

  // get the skin from the module config
  const moduleData = getModuleDataByModuleType(
    state,
    ModuleType.COVER_DEVIATION
  );
  if (!moduleData) {
    return undefined;
  }
  const skinId = moduleData?.profileSkin?.templateName;

  if (skinId) {
    if (skinId === 'official') {
      return officialSkin;
    }
    if (skinId === 'custom') {
      return getCustomSkin(state);
    }
    if (isPapiFlagEnabled) {
      const stream = getStream<ProfileSkin>(state, profileSkinsStreamId);
      return stream.items.find(
        s => s.skinId === moduleData.profileSkin.templateName
      );
    }
    return premiumSkins.find(
      s => s.skinId === moduleData.profileSkin.templateName
    );
  }
  return undefined;
};
